interface LocalStorageData {
  isLoggedIn: boolean;
  isLoginPending: boolean;
  lastUpdate: number;
  userInfo: unknown;
  loginError?: string;
  [key: string]: unknown;
}

class LocalStorage {
  storageKey: string;

  expireIn: number;

  data: LocalStorageData;

  constructor() {
    this.storageKey = 'bwm_data';
    this.expireIn = 1000 * 60 * 60;
    // this.expireIn = 1000 * 1;

    this.data = {
      isLoggedIn: false,
      isLoginPending: false,
      lastUpdate: new Date().getTime(),
      userInfo: null,
      loginError: '',
    };

    this.#load();
  }

  #save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.data));
  }

  #load() {
    const str = localStorage.getItem(this.storageKey);
    if (!str) {
      return;
    }

    const data = JSON.parse(str);
    if (new Date().getTime() > (+data.lastUpdate + this.expireIn)) {
      data.isLoggedIn = false;
    }

    this.data = data;
  }

  get() {
    return this.data;
  }

  persist(state: LocalStorageData) {
    state.lastUpdate = new Date().getTime();
    this.data = { ...state };
    delete this.data.loginError;
    this.#save();
  }
}

export default new LocalStorage();
